import { render, staticRenderFns } from "./HistoriaSmapa.vue?vue&type=template&id=4b8f2974&scoped=true"
import script from "./HistoriaSmapa.vue?vue&type=script&lang=ts"
export * from "./HistoriaSmapa.vue?vue&type=script&lang=ts"
import style0 from "./HistoriaSmapa.vue?vue&type=style&index=0&id=4b8f2974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f2974",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QVideo from 'quasar/src/components/video/QVideo.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QImg,QToolbar,QBtn,QDrawer,QScrollArea,QList,QItem,QItemSection,QItemLabel,QVideo});qInstall(component, 'directives', {ClosePopup});
